import React, { Component } from 'react'
import { connect } from 'react-redux'

import { Card, Table, Button, Tag, Tooltip, Typography, Modal, Input, Badge } from 'antd'

import { req_page_ars_qualify } from '../../api'
import { usrRole } from '../../utils/dataUtil'

import { PAGE_SIZE, SORT_FIELD_NAME, SORT_UP_DOWN } from '../../utils/contrains'

import ReservationLogModal from './reservation-log-modal'

const { Text } = Typography;

class ApplylogReservation extends Component {

    state = {
        loading: false,
        userLevel: 'NORMAL',
        item: {},
        // 分頁參數
        items: [],
        pagination: {
            current: 1,
            pageSize: PAGE_SIZE,
            total: 0
        },
        columnSort: SORT_FIELD_NAME,
        orderBy: SORT_UP_DOWN,
        searchField: 'EligibleName',
        searchValue: '',
        filterStatus: '',

        domnloadFile: '',
        isShowModal: false,


    }

    UNSAFE_componentWillMount() {
        this.init_columns()
    }

    componentDidMount() {
        this.api_page_items(1)
    }

    // 遠端數據處理 //////////////////////////////////////////////
    api_page_items = async (current) => {
        this.current = current // 保存當前頁，給其他方法可看到
        const { pageSize } = this.state.pagination
        const { searchField, searchValue, columnSort, orderBy, filterStatus } = this.state
        const { token, userCode, role } = this.props.user

        var userLevel = usrRole(role)
        this.setState({ userLevel: userLevel })

        this.setState({ loading: true })
        const result = await req_page_ars_qualify(userCode, userLevel, current, pageSize, columnSort, orderBy, searchField, searchValue, filterStatus, token)
        this.setState({ loading: false })

        //console.log(result)
        if (result.total > 0) {
            const { total } = result
            const items = result.data
            const pagination = { current: this.current, pageSize: this.state.pagination.pageSize, total }
            this.setState({ items, pagination })
            //console.log(this.state);
        } else {
            const items = []
            const pagination = { current: 1, pageSize: this.state.pagination.pageSize, total: 0 }
            this.setState({ items, pagination })
        }
    }


    // 數據配置設定 ////////////////////////////////////////////// 
    init_columns = () => {
        this.columns = [
            {
                title: '獎項名稱',
                dataIndex: 'QualifyDscription',
                width: 40,
                render: (text, item) => {
                    return (
                        <>
                            <Text type="warning"><i className="fas fa-award"></i></Text>{' '}<span> {text}</span>
                        </>
                    )
                }
            },
            {
                title: '獲獎人',
                dataIndex: 'EligibleName',
                width: 35,
                responsive: ['md'],
            },
            {
                title: '領取狀態',
                width: 40,
                responsive: ['md'],
                render: (item) => {
                    const { EligibleStatus, ReservationType, Id } = item
                    let color = this.style_switch_color_tag('EligibleStatus', EligibleStatus)
                    return (
                        <>
                            <Tag color={color} key={Id}>
                                {(EligibleStatus === 'ACCEPT') ? '未領取' : ''}
                                {(EligibleStatus === 'CASEEND' && ReservationType === 'SENDMAIL') ? '已處理' : ''}
                                {(EligibleStatus === 'CASEEND' && ReservationType === 'ONSITE') ? '已領取' : ''}
                            </Tag>
                        </>
                    )
                }
            },
            {
                title: '',
                dataIndex: '',
                width: 60,
                render: (item) => {
                    const { LogTotal } = item
                    return (LogTotal > 0 ?
                        (
                            <>
                                <Badge count={LogTotal} size="default">
                                    <Button type="primary" size='small' onClick={() => this.handle_show_ui_reservation_log(item)} ><i className="far fa-clipboard"></i><span> 過往預約紀錄</span></Button> {' '}
                                </Badge>
                            </>
                        ) : ''
                    )
                },

            },
        ]
    }

    style_switch_color_tag(column, param) {
        switch (column) {
            case 'EligibleStatus':
                switch (param) {
                    case 'ACCEPT':
                        return 'red'
                    case 'CASEEND':
                        return 'green'
                    default:
                        return 'default';
                }
            default:
                break;
        }
    }

    // 操作互動處理 //////////////////////////////////////////////   
    handle_page_size_change = (current, size) => {
        //console.log(size)
        this.setState({
            pagination: {
                current: current,
                pageSize: size
            }
        }, () => {
            this.api_page_items(current)
        })
    }

    handle_table_change = (pagination, filters, sorter, extra) => {
        if (filters) {
            const status = [...Object.values(filters).filter(Boolean)][0]
            if (status) {
                this.setState({ filterStatus: status }, () => {
                    this.api_page_items(pagination.current)
                });
            } else {
                this.setState({ filterStatus: '' }, () => {
                    this.api_page_items(pagination.current)
                });
            }
        } else {
            this.api_page_items(pagination.current)
        }
    }

    handle_data_refresh = () => {
        this.api_page_items(this.current)
    }

    handle_data_download = () => {
        this.api_downloadfile_items()
    }

    handle_show_ui_reservation_log = (item) => {
        this.setState({ isShowModal: true, item })
    }

    /////////////////////////////////////////////////////////////     
    render() {
        const { loading, item, items, pagination, searchValue, isShowModal} = this.state
        const title = (
            <span>
                <span>領獎人姓名：</span>
                <Input placeholder="領獎人姓名" style={{ width: 150, margin: '0 5px' }} value={searchValue} onChange={event => this.setState({ searchValue: event.target.value })} />
                <Button type='primary' onClick={() => this.api_page_items(1)}><i className="fas fa-search element-hidden"></i> 查詢</Button>
                <Tooltip placement="top" title="重新整理"><Button type='primary' onClick={() => this.handle_data_refresh()}><i className="fas fa-sync-alt"></i></Button></Tooltip>
            </span>
        )
        return (
            <Card title={title} >
                <Table
                    bordered
                    scroll={{ y: 480 }}
                    loading={loading}
                    rowKey='KeyId'
                    dataSource={items}
                    onChange={this.handle_table_change}
                    pagination={{
                        ...pagination,
                        responsive: true,
                        showQuickJumper: true,
                        showSizeChanger: true,
                        pageSizeOptions: [5, 10, 20, 50, 100],
                        // onChange: this.api_page_applycase,
                        onShowSizeChange: this.handle_page_size_change
                    }}
                    columns={this.columns}
                />
                <Modal
                    destroyOnClose={true}
                    title="預約紀錄"
                    visible={isShowModal}
                    onOk={() => {
                        this.setState({ isShowModal: false })
                        this.api_page_items(this.current)
                    }}
                    onCancel={() => {
                        this.setState({ isShowModal: false })
                    }}
                >
                    <ReservationLogModal qualify={item} />
                </Modal>
            </Card>
        )
    }
}

export default connect(
    state => ({ user: state.user }),
    {}
)(ApplylogReservation)